import { resizeHandleDimensions, resizeHandleTypes } from 'InpageEditorUI/lib/layoutSection/constants';
export const isResizeHandleType = type => {
  return type === resizeHandleTypes.RESIZE_HANDLE_LEFT || type === resizeHandleTypes.RESIZE_HANDLE_RIGHT || type === resizeHandleTypes.RESIZE_HANDLE_BETWEEN;
};
const getResizeStepSize = (leftColumn, rightColumn) => {
  return (rightColumn.right - leftColumn.left) / (leftColumn.unitsWide + rightColumn.unitsWide);
};

// Quadratic easing function for varying step size based on step number
const easeOutFunction = (stepNumber, column) => {
  const x = stepNumber / (column.unitsWide - 1);
  return 1 - (1 - x) * (1 - x);
};
const getStepMinimum = (column, stepNumber, stepSize, isLeftStep) => {
  const adjustedStepSize = isLeftStep ? easeOutFunction(column.unitsWide - stepNumber, column) * stepSize : easeOutFunction(stepNumber, column) * stepSize;
  const midX = isLeftStep ? column.right - (column.unitsWide - stepNumber) * adjustedStepSize : column.left + stepNumber * adjustedStepSize;
  if (stepNumber === 1) {
    return isLeftStep ? column.left : midX - adjustedStepSize / 2;
  }
  return midX - adjustedStepSize / 2;
};
const getMouseXPositionToTrigger = (column, stepNumber, stepSize, isLeftStep) => {
  // Get the step size based on the step number, steps closer to the drag line
  // are narrow to make dragging more responsive.
  const adjustedStepSize = isLeftStep ? easeOutFunction(column.unitsWide - stepNumber, column) * stepSize : easeOutFunction(stepNumber, column) * stepSize;
  const midXPositionofCurrentStep = isLeftStep ? column.right - (column.unitsWide - stepNumber) * adjustedStepSize : column.left + stepNumber * adjustedStepSize;
  const adjustedHalfStep = adjustedStepSize / 2;
  let minXPositionToTrigger;
  let maxXPositionToTrigger;

  // If this is the left most column point (aka step) for the column
  if (stepNumber === 1) {
    // Extend min range to left edge of the column
    minXPositionToTrigger = column.left;
  } else {
    minXPositionToTrigger = midXPositionofCurrentStep - adjustedHalfStep;
  }

  // If this is the right most column point (aka step) for the column
  if (stepNumber + 1 === column.unitsWide) {
    // Extend max range to the right edge of the column
    maxXPositionToTrigger = column.right;
  } else {
    // Use the minimum x position to trigger of the next step as the maximum
    maxXPositionToTrigger = getStepMinimum(column, stepNumber + 1, stepSize, isLeftStep);
  }
  return {
    min: minXPositionToTrigger,
    max: maxXPositionToTrigger
  };
};

// In LayoutSectionDragLayer, use the min/max X values from here to determine
// which "step" to apply to the columns based on where the mouse X pos is.
export const calculateResizeSteps = (leftColumn, rightColumn) => {
  const totalUnits = leftColumn.unitsWide + rightColumn.unitsWide;
  const steps = [];
  const stepSize = getResizeStepSize(leftColumn, rightColumn);

  // Add steps for resizing columns to the left
  if (leftColumn.unitsWide > 1) {
    for (let i = 1; i < leftColumn.unitsWide; i++) {
      const mouseXPositionToTrigger = getMouseXPositionToTrigger(leftColumn, i, stepSize, true);
      steps.push({
        leftColumnSizeWouldBe: i,
        rightColumnSizeWouldBe: totalUnits - i,
        mouseXPositionToTrigger
      });
    }
  }

  // Add step for putting columns back to original position
  if (leftColumn.unitsWide > 1 || rightColumn.unitsWide > 1) {
    steps.push({
      leftColumnSizeWouldBe: leftColumn.unitsWide,
      rightColumnSizeWouldBe: rightColumn.unitsWide,
      mouseXPositionToTrigger: {
        min: leftColumn.right,
        max: rightColumn.left
      }
    });
  }

  // Add steps for resizing columns to the right
  if (rightColumn.unitsWide > 1) {
    for (let i = 1; i < rightColumn.unitsWide; i++) {
      const mouseXPositionToTrigger = getMouseXPositionToTrigger(rightColumn, i, stepSize, false);
      steps.push({
        leftColumnSizeWouldBe: leftColumn.unitsWide + i,
        rightColumnSizeWouldBe: totalUnits - (leftColumn.unitsWide + i),
        mouseXPositionToTrigger
      });
    }
  }
  return steps;
};
export const getPositionInfoForResizeHandle = (leftColumn, rightColumn, parentRow) => {
  if (leftColumn && leftColumn.hasBounds && rightColumn && rightColumn.hasBounds && (leftColumn.unitsWide !== -1 || rightColumn.unitsWide !== -1)) {
    const gutterWidth = rightColumn.left - leftColumn.right;
    const handleHeight = parentRow.height * resizeHandleDimensions.HEIGHT_SCALE;
    const handleLeft = (gutterWidth - resizeHandleDimensions.WIDTH) / 2;
    const halfHeightPointOfModule = parentRow.height / 2;
    const handleTop = halfHeightPointOfModule - handleHeight / 2;
    return {
      handleHeight,
      handleTop,
      handleLeft,
      gutterHeight: parentRow.height,
      gutterTop: parentRow.top,
      gutterLeft: leftColumn.right,
      gutterWidth,
      leftColumn,
      rightColumn
    };
  }
  return null;
};